var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('ReleasesPgHeader'),_c('section',{staticClass:"form-full-width"},[_c('FormReleasesPg',{attrs:{"loading":_vm.loading,"getReleasesPg":_vm.getReleasesPg},on:{"beforeUpdate":_vm.updateReleasesPg}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }